import enData from '../locales/en.json';
import ruData from '../locales/ru.json';

// Non-localized data (like URLs) stays the same regardless of language
const commonData = {
  socialLinks: [
    {
      platform: 'github',
      url: 'https://github.com/afedotov89',
      label: 'GitHub profile'
    },
    {
      platform: 'telegram',
      url: 'https://t.me/afedotov89',
      label: 'Telegram profile'
    },
    {
      platform: 'vk',
      url: 'https://vk.com/a_fedotov/',
      label: 'VK profile'
    },
    {
      platform: 'instagram',
      url: 'https://www.instagram.com/a_fedotov/',
      label: 'Instagram profile'
    },
    {
      platform: 'x',
      url: 'https://x.com/a_fedotov',
      label: 'X profile'
    },
    {
      platform: 'linkedin',
      url: 'https://www.linkedin.com/in/alexander-fedotov',
      label: 'LinkedIn profile'
    }
  ],
  footer: {
    emailAddress: "email@example.com",
    telegramUrl: "https://t.me/afedotov89",
    telegramUsername: "@afedotov89"
  }
};

// Function to get data based on language
const getProfileData = (language) => {
  const localeData = language === 'ru' ? ruData : enData;

  return {
    // Combine locale-specific data with common data
    name: localeData.header.name,
    description: localeData.header.description,
    socialLinks: commonData.socialLinks,
    timelineEntries: localeData.timeline.items,
    timelineTitle: localeData.timeline.title,
    sideProjects: localeData.sideProjects.items,
    sideProjectsTitle: localeData.sideProjects.title,
    sideProjectsDescription: localeData.sideProjects.description,
    footer: {
      ...commonData.footer,
      contact: localeData.footer.contact,
      emailLabel: localeData.footer.email,
      telegramLabel: localeData.footer.telegram,
      copyright: localeData.footer.copyright
    }
  };
};

export default getProfileData;